<template>
  <div
    class="login-background max-h-screen min-h-screen bg-white flex overflow-hidden"
  >
    <div
      class="flex-1 flex flex-col justify-center z-10 w-full py-1/2 px-4 sm:px-6 md:max-w-96 md:py-1/4 md:justify-start lg:justify-center lg:max-w-lg lg:py-12 lg:flex-none lg:pl-20 xl:ml-24 2xl:pl-14 2xl:ml-32"
    >
      <div class="">
        <a
          href="https://neopass.fr"
          class="flex items-center"
        >
          <icon
            name="logo-neopass"
            class="text-indigo-600 w-max-content w-max"
          />
        </a>

        <div class="mt-8">
          <form
            action="#"
            @submit.prevent="login"
          >
            <input-text
              id="username"
              class="w-full mt-1"
              name="username"
              libelle=""
              :value="form.username"
              @input="
                (newValue) => {
                  form.username = newValue;
                }
              "
              :big="true"
              placeholder="Adresse email ou identifiant"
              :voiceInput="false"
            />

            <div class="mt-6">
              <input-text
                class="w-full mt-1"
                name="password"
                libelle=""
                type="password"
                :value="form.password"
                @input="
                  (newValue) => {
                    form.password = newValue;
                  }
                "
                :big="true"
                placeholder="Mot de passe"
              />
            </div>

            <div class="mt-2 flex justify-end">
              <div class="text-sm leading-5">
                <router-link
                  :to="{ name: 'ForgotPassword' }"
                  class="text-indigo-600 hover:text-indigo-400 focus:outline-none focus:underline transition ease-in-out duration-150"
                >
                  Mot de passe oublié
                </router-link>
              </div>
            </div>

            <div
              class="mt-6 space-y-4 flex flex-col items-center justify-between sm:space-y-0 sm:flex-row"
            >
              <big-action-button
                border-color="border-transparent"
                text-color="text-white"
                bg-color="bg-pink-600"
                bg-color-square="bg-pink-600"
                icon-color="text-white"
                libelle="CONNEXION"
                :spinner="loading"
                :right="true"
                icon="arrow-right_1"
                type-shadow="shadow-pink"
              />

              <router-link :to="{ name: 'Register' }">
                <big-action-button
                  border-color="border-pink-600"
                  text-color="text-pink-600"
                  bg-color="bg-white"
                  bg-color-square="bg-white"
                  icon-color="text-pink-600"
                  libelle="INSCRIPTION"
                  :right="true"
                  icon="plus-circle"
                />
              </router-link>
            </div>

            <v-errors
              :errors="{ ...errors }"
              class="mt-6 text-sm text-center text-red-500"
            />
          </form>
        </div>
      </div>
    </div>
    <!--         <div class="hidden lg:inline-block relative z-0
                transform
                xl:scale-75 xl:right-64 xl:top-5
                xxl:scale-100 xxl:top-16 xxl:right-52
                2xl:scale-125 2xl:top-48 2xl:-right-28
                3xl:scale-150 3xl:top-80 3xl:-right-32
            "
        >
            <illustration name="login" />
        </div> -->
    <!-- BEGIN Help button -->
    <help-button
      @helpClick="showHelp = true"
      class="z-10"
    />
    <!-- END Help button -->

    <!-- BEGIN Help popup -->
    <help
      :show-help="showHelp"
      @close="showHelp = false"
    />
    <!-- END Help popup -->

    <!-- BEGIN Session expire popup -->
    <session-expire-popup
      :is-show="isSessionExpired"
      @close="isSessionExpired = false"
    />
    <!-- END Session expire popup -->
  </div>
</template>

<script>
import Help from './popup/Help';
import { mapActions } from 'vuex';
import Icon from './../../components/Icon';
import InputText from './../../components/Inputs/InputText';
import BigActionButton from '../../components/BigActionButton';
import HelpButton from './../../components/HelpButton';
import SessionExpirePopup from './../../components/Login/SessionExpire.vue';

export default {
  name: 'LoginPage',

  components: {
    Help,
    Icon,
    InputText,
    BigActionButton,
    HelpButton,
    SessionExpirePopup,
  },

  data() {
    return {
      form: {
        username: '',
        password: '',
      },
      loading: false,
      errors: null,
      showHelp: false,
      isSessionExpired: false,
    };
  },

  mounted() {
    if (this.$route.params.session === 'sessionExpired') {
      this.isSessionExpired = true;
    }
  },

  methods: {
    ...mapActions({
      loginAction: 'auth/login',
    }),

    async login() {
      this.loading = true;
      this.errors = null;
      try {
        await this.loginAction(this.form);
        await this.$router.replace({ name: 'Dashboard' });
      } catch (error) {
        console.log(error);
        this.errors = { errors: { msg: error.message } };
      }
      this.loading = false;
    },

    switchVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === 'password' ? 'text' : 'password';
    },
  },
};
</script>
